import { Stack } from '@mui/material';
import { ISuppliersResource } from 'API/Suppliers/suppliers';
import { CheckboxInput } from 'Components';
import { TherapySuppliersContext } from 'Context/SuppliersContext/TherapySuppliersContext';
import { useContext } from 'react';
import { ResetFilterButtons } from '../../ResetFilterButtons';
import { checkboxHandler } from 'Utils/supplierFilterManager';
import { SUPPLIER_RESULT_FILTER } from 'Enum/suppliers';

export const Specialties = () => {
  const { filters, setFilters, dispatchSuppliers, treatmentMethods } =
    useContext(TherapySuppliersContext);

  const resetTreatMethodsCheckboxes = () => {
    const updatesFilters = {
      ...filters,
      treatMethod: [],
    };
    setFilters(updatesFilters);
    dispatchSuppliers({
      type: SUPPLIER_RESULT_FILTER.Therapy,
      payload: { value: updatesFilters },
    });
  };

  const sortByCheckmarkHandler = (
    a: ISuppliersResource,
    b: ISuppliersResource
  ) => {
    const isACheckmarked = filters.treatMethod?.includes(a.resourceId);
    const isBCheckmarked = filters.treatMethod?.includes(b.resourceId);

    if (isACheckmarked && !isBCheckmarked) return -1;
    if (!isACheckmarked && isBCheckmarked) return 1;

    return a.content.localeCompare(b.content);
  };

  return (
    <Stack
      sx={{
        pb: '50px',
      }}
      tabIndex={-1}
    >
      {treatmentMethods?.resources
        ?.sort((a, b) => sortByCheckmarkHandler(a, b))
        .map((specialty: ISuppliersResource, index: number) => {
          const isChecked =
            filters.treatMethod?.some(
              (treatMethodId) => treatMethodId === specialty.resourceId
            ) || false;
          return (
            <CheckboxInput
              key={index}
              checked={isChecked}
              label={specialty.content}
              onChange={() => {
                const updatesFilters = {
                  ...filters,
                  treatMethod: checkboxHandler(
                    filters.treatMethod,
                    specialty.resourceId
                  ),
                };
                setFilters(updatesFilters);
                dispatchSuppliers({
                  type: SUPPLIER_RESULT_FILTER.Therapy,
                  payload: { value: updatesFilters },
                });
              }}
              containerStyle={{
                '.MuiCheckbox-root': {
                  m: '8px 0',
                  p: '0 5px 0 16px',
                },
              }}
              textSx={{
                fontWeight: isChecked ? '600 !important' : undefined,
                ':hover': {
                  fontWeight: 600,
                },
              }}
            />
          );
        })}
      <ResetFilterButtons
        resetCallback={() => resetTreatMethodsCheckboxes()}
        sx={{
          pl: '8px',
          justifyContent: 'flex-start',
        }}
      />
    </Stack>
  );
};
